module.exports = {
      id: "qatar-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#qatar",
      toString: function () {
        return this.url;
      }
    }